import React from "react";
import HdfcHeader from "../components/pageBlocks/hdfcHeader";
import errorCar from "../../assets/images/animations/Error.json";
import LottieAnimation from "../components/lottieAnimation";

function ErrorTechnical() {
    window.scrollTo(0, 0);
    return (
        <div className="wrapper">
            <HdfcHeader />
            <section className="confirm-wrap mt-110">
                <div className="container mx-auto px-5">
                    <div className="congrats-screen w-full">
                        <div className="flex justify-center mx-auto car-img-wrap mb-3 md:mb-6">
                            <LottieAnimation
                                width={230}
                                height={180}
                                animationData={errorCar}
                            />
                        </div>

                        <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-11/12 mx-auto">
                            Due to technical reasons, we are unable to process
                            the loan.
                        </h1>

                        <p className="openSans-Light text-center text-base sm:text-xl md:text-2xl">
                            Please contact your HDFC Bank branch for further
                            assistance.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ErrorTechnical;
